import { MusicAPIIntegrationID } from 'fym-shared/src/music-services/ids';
import { CatalogItem } from '../../../redux/api/fymAPI.types';

/**
 * What the sheet is working on. Everything else it shows is derived from this
 * plus what the resolver has answered so far, which is why the sheet never has
 * to ask what kind of page is being made.
 */
export type CreationSource =
  | { kind: 'none' }
  | { kind: 'catalogTrack'; trackMaid: string; item?: CatalogItem; title?: string; artistName?: string }
  | { kind: 'catalogRow'; item: CatalogItem }
  | { kind: 'url'; url: string }
  | { kind: 'manual'; query: string }
  | { kind: 'blank' };

/** Which face the sheet is showing. Derived, never stored. */
export enum CreationStage {
  start = 'start',
  resolving = 'resolving',
  resolved = 'resolved',
  manual = 'manual',
  duplicate = 'duplicate',
  blank = 'blank',
}

/**
 * The marks under the omni field. Six of the twenty services we search, chosen
 * because they are the ones an artist recognises at a glance — the line beside
 * them says the rest are found for you.
 */
export const promotedServices: MusicAPIIntegrationID[] = [
  MusicAPIIntegrationID.Spotify,
  MusicAPIIntegrationID.AppleMusic,
  MusicAPIIntegrationID.Tidal,
  MusicAPIIntegrationID.AmazonMusic,
  MusicAPIIntegrationID.Deezer,
  MusicAPIIntegrationID.YoutubeMusic,
];
